<div>
    <div [matMenuTriggerFor]="menu">
        <i class="fas fa-ellipsis-v clickable menuIcon padding-1"></i>
    </div>
    <mat-menu #menu class="padding-1">
        <mat-checkbox (change)="masterToggle()" [checked]="hasValue() && allSelected()"
            [indeterminate]="hasValue() && !allSelected()" (click)="$event.stopPropagation()">
            {{allSelected() ? ('deselectAll' | translate) : ('selectAll' | translate) }}
        </mat-checkbox>
        <div *ngFor="let column of optionColumns">
            <div>
                <mat-checkbox name="checkbox" (click)="$event.stopPropagation()"
                    (change)="onCheckDisplay($event, column)" [checked]="column.checked">
                    {{column.columnLabel}}
                </mat-checkbox>
            </div>
        </div>
    </mat-menu>
</div>